var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"has-background-white is-border is-margin-top"},[_c('options-light-list',{attrs:{"options":_vm.programOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }